<mat-drawer-container style="height: 100%">
  <mat-drawer-content style="background: white">
    <h3>その他の作業実施内容</h3>
    <div class="left-pane">
      <table class="event-list">
        <thead>
        <tr>
          <th>予定日</th>
          <th>日齢</th>
          <th>作業名</th>
          <th>対象のロット</th>
        </tr>
        </thead>
        <tbody *ngIf="selectedMeisais && selectedMeisais.length > 0">
        <tr *ngFor="let event of selectedMeisais;">
          <td>{{event?.yoteiDate}}</td>
          <td>{{event?.yoteiNichirei}}</td>
          <td>{{event?.eventName}}</td>
          <td>
            <span *ngIf="event?.taishouLotName">{{event?.taishouLotName}}</span>
            <span *ngIf="!event?.taishouLotName">
              {{commonService.getName(masterService.keishaMaster,
                                      event?.taishouKeisha,
                                      'farmKeisha')}}</span>
            <span></span>
          </td>
        </tr>
        </tbody>
      </table>
      <br>
      <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-slide-toggle style="margin-left: 20px;" [(ngModel)]="editEvent">予定日を編集する</mat-slide-toggle>
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer style="width: 40%"opened position="end" mode="side">
    <div class="right-pane">
      <form #jisshiForm="ngForm" *ngIf="!editEvent">
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field appearance="legacy" style="padding-bottom: 10px">
            <mat-label>実施日</mat-label>
            <input matInput [matDatepicker]="jisshiDatePicker" [(ngModel)]="inputForm.jisshiDate" name="jisshiDate" readonly
                   (click)="jisshiDatePicker.open()" (dateChange)="eventService.updateJisshiNichirei2(inputForm, edukeDate)">
            <mat-datepicker-toggle matSuffix [for]="jisshiDatePicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #jisshiDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施日齢
            </mat-label>
            <input matInput placeholder="実施日齢" required disabled
                   name="jisshiNichirei" [(ngModel)]="inputForm.jisshiNichirei">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施者
            </mat-label>
            <input matInput placeholder="実施者" required
                   name="jisshiSha" [(ngModel)]="inputForm.jisshiSha">
          </mat-form-field>
        </div>
        <br>
        <div fxLayout="row wrap" fxLayoutGap="12px" style="margin-bottom: 12px">
          <div [matTooltip]="commonService.getAlertTooltipMessage(jisshiForm)"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="primary" [disabled]="jisshiForm.invalid"
                    (click)="register();">登録
            </button>
          </div>
          <div [matTooltip]="!selectedMeisais[0].jisshiDate ? '実施内容が登録されていません。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="accent"
                    [disabled]="!selectedMeisais[0].jisshiDate"
                    (click)="undo();">取り消し
            </button>
          </div>
          <div [matTooltip]="selectedMeisais[0].jisshiDate ? '実施内容を取り消してから削除してください。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="warn"
                    [disabled]="!!selectedMeisais[0].jisshiDate"
                    (click)="delete();">削除
            </button>
          </div>
        </div>
      </form>
      <div *ngIf="editEvent">
        <app-event-edit [selectedMeisais]="selectedMeisais"></app-event-edit>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
